import { render, staticRenderFns } from "./LinkedOccurrence.vue?vue&type=template&id=f272629e"
import script from "./LinkedOccurrence.vue?vue&type=script&lang=ts"
export * from "./LinkedOccurrence.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports